<template>
  <b-card v-if="review" class="review-item">
    <div
      class="review-item__header w-100 d-flex justify-content-between align-items-center"
    >
      <div class="d-flex">
        <b-avatar :src="reviewerAvatar" size="40px" class="mr-3"></b-avatar>
        <div class="d-flex flex-column justify-content-center">
          <h5>{{ reviewerName }}</h5>
          <label>{{ reviewDate }}</label>
        </div>
      </div>
      <div>
        <rate disabled :value="review.rating"></rate>
      </div>
    </div>
    <div class="review-item__content">
      <p v-if="isTooLong && !more">
        {{ review.text | tooLong(maxReviewLength) }}
      </p>
      <p v-else>{{ review.text }}</p>
      <span v-if="isTooLong" class="more" @click="showMore">{{
        more ? 'Show less' : 'Show more'
      }}</span>
    </div>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Review Item
 * ==================================================================================
 **/

import Review from '@/models/Review'
import Rate from '@/components/inputs/Rate'

export default {
  components: {
    Rate
  },
  props: {
    review: {
      type: [Review, Object],
      required: true
    },
    maxReviewLength: {
      type: Number,
      default: 320
    }
  },
  computed: {
    reviewDate() {
      return this.review ? this.parseDate(this.review.created_at) : 'NA'
    },

    reviewer() {
      return this.review && this.review.reviewer ? this.review.reviewer : null
    },

    reviewerName() {
      return this.reviewer ? this.reviewer.full_name : null
    },

    reviewerAvatar() {
      return this.reviewer
        ? this.reviewer.avatar_permanent_thumb_url ||
            this.reviewer.avatar_permanent_url
        : null
    },

    isTooLong() {
      if (!this.review) return
      return this.review.text.length > this.maxReviewLength
    }
  },
  data: function() {
    return {
      more: false
    }
  },

  methods: {
    showMore() {
      this.more = !this.more
    }
  }
}
</script>
<style scoped lang="scss">
.review-item {
  border-radius: 1.125rem;

  &-body {
    padding: 1.25rem;
  }

  .review-item__header {
    margin-bottom: 15px;

    h5 {
      font-weight: 600;
      margin-bottom: 0;
    }

    label {
      font-size: 0.85rem;
      margin-bottom: 0;
      color: #6c6c6c;
    }

    .b-avatar {
      border: 1px solid #7b8591;
    }
  }

  .review-item__content {
    p {
      font-size: 0.95rem;
      line-height: 1.1rem;
      margin-bottom: 0;
    }

    .more {
      font-size: 0.9rem;
      display: inline-block;
      margin-top: 5px;
      margin-right: 5px;
      color: #3498db;
      cursor: pointer;
    }
  }
}
</style>
